import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "./Redux/useAuth";

interface PrivateRouteProps {
  component: ReactElement;   // ✅ не ReactNode, а ReactElement
  redirectTo?: string;
}

const PrivateRoute = ({ component, redirectTo = "/sign-in" }: PrivateRouteProps) => {
  const { isLoggedIn, isRefreshing } = useAuth();

  if (isRefreshing) {
    return <b>Refreshing user...</b>; // або спінер
  }

  return isLoggedIn ? component : <Navigate to={redirectTo} />;
};

export default PrivateRoute;
